export const FETCH_STUDENT_PROGRESS_REQUEST = 'FETCH_STUDENT_PROGRESS_REQUEST';
export const FETCH_STUDENT_PROGRESS_SUCCESS = 'FETCH_STUDENT_PROGRESS_SUCCESS';
export const FETCH_STUDENT_PROGRESS_FAILURE = 'FETCH_STUDENT_PROGRESS_FAILURE';

export const FETCH_SINGLE_STUDENT_PROGRESS_REQUEST = 'FETCH_SINGLE_STUDENT_PROGRESS_REQUEST';
export const FETCH_SINGLE_STUDENT_PROGRESS_SUCCESS = 'FETCH_SINGLE_STUDENT_PROGRESS_SUCCESS';
export const FETCH_SINGLE_STUDENT_PROGRESS_FAILURE = 'FETCH_SINGLE_STUDENT_PROGRESS_FAILURE';

export const EXPORT_PROGRESS_REPORT_REQUEST = 'EXPORT_PROGRESS_REPORT_REQUEST';
export const EXPORT_PROGRESS_REPORT_SUCCESS = 'EXPORT_PROGRESS_REPORT_SUCCESS';
export const EXPORT_PROGRESS_REPORT_FAILURE = 'EXPORT_PROGRESS_REPORT_FAILURE';

export const SET_PROGRESS_FILTERS = 'SET_PROGRESS_FILTERS';
export const CLEAR_PROGRESS_FILTERS = 'CLEAR_PROGRESS_FILTERS';

export const SET_SELECTED_STUDENT = 'SET_SELECTED_STUDENT';
export const CLEAR_SELECTED_STUDENT = 'CLEAR_SELECTED_STUDENT';